// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responses-add-ons-popup {
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    z-index: 11;
    width: 100%;
    height: 100%;
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    background-color: #0000004C;
}

.responses-add-ons {
    width: 700px;
    height: 350px;
    border-radius: 10px;
    background: #FFFFFF;
}

.responses-add-ons-body {
    display: flex;
    margin: 30px 0;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/responses-add-ons.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;AAC3B","sourcesContent":[".responses-add-ons-popup {\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    z-index: 11;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    position: fixed;\n    align-items: center;\n    justify-content: center;\n    background-color: #0000004C;\n}\n\n.responses-add-ons {\n    width: 700px;\n    height: 350px;\n    border-radius: 10px;\n    background: #FFFFFF;\n}\n\n.responses-add-ons-body {\n    display: flex;\n    margin: 30px 0;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
